export const ROUTES = {
  dashboard: "/dashboard",
  onboarding: "/onboarding",
  connectAccount: "/connect-account",
  buildProfile: "/build-profile",
  nicheSelection: "/niche-selection",
  addAccount: (platform: string) => `/add-account?platform=${platform}`,
  guestAddAccount: (platform: string) => `/add-account?platform=${platform}&guest=true`,
  profileSummary: "/profile-summary",
  approvalPending: "/appeal-review",
  appealExpired: "/appeal-expired",
  waitlist: "/waitlist",
  login: "/login",
  estimateEarnings: "/estimate-earnings",
};

export const API_ROUTES = {
  enrichmentRun: "/api/creator/enrichment/run",
  enrichmentStatus: "/api/creator/enrichment/status",
  profileReadiness: "/api/auth/onboarding/profile-readiness",
  enrichmentSummary: "/api/auth/enrichment/summary",
};
